import { Component, inject } from '@angular/core';
import { SmartAssistantImportService } from '../smart-assistant-import.service';

@Component({
    standalone: false,
    selector: 'app-smart-assistant-completion-step',
    templateUrl: './smart-assistant-completion-step.component.html'
})
export class SmartAssistantCompletionStepComponent {
    readonly service = inject(SmartAssistantImportService);
}
